import React from 'react'
import PropTypes from 'prop-types'

const DescriptionMarkField = ({ mark }) =>
  <p className="text-pre-wrap tw:mb-0! tw:lg:w-1/2 tw:text-gray-950">{mark.question.description}</p>

DescriptionMarkField.propTypes = {
  mark: PropTypes.shape({
    question: PropTypes.shape({
      description: PropTypes.string
    })
  }).isRequired
}

export default DescriptionMarkField
